import { render, staticRenderFns } from "./rewardSetting.vue?vue&type=template&id=63c7ec9e"
import script from "./rewardSetting.vue?vue&type=script&lang=js"
export * from "./rewardSetting.vue?vue&type=script&lang=js"
import style0 from "./rewardSetting.vue?vue&type=style&index=0&id=63c7ec9e&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c7ec9e')) {
      api.createRecord('63c7ec9e', component.options)
    } else {
      api.reload('63c7ec9e', component.options)
    }
    module.hot.accept("./rewardSetting.vue?vue&type=template&id=63c7ec9e", function () {
      api.rerender('63c7ec9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/rewardSetting.vue"
export default component.exports